import { render, staticRenderFns } from "./FormCesionDerecho.vue?vue&type=template&id=02fc90bf&"
import script from "./FormCesionDerecho.vue?vue&type=script&lang=ts&"
export * from "./FormCesionDerecho.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports